import { getAxiosInstance } from '../api.client';
import {
    type ExternalTask,
    type ExternalTaskDetail,
    type ExternalTaskFormModel,
} from './externalTasks.models';

export async function getExternalTasks(
    projectId: string,
): Promise<ExternalTaskDetail[]> {
    const response = await getAxiosInstance().get<ExternalTaskDetail[]>(
        `/project/${projectId}/external-task`,
    );
    return response.data;
}

export async function getExternalTaskById(
    projectId: string,
    id: string,
): Promise<ExternalTaskDetail> {
    const response = await getAxiosInstance().get<ExternalTaskDetail>(
        `/project/${projectId}/external-task/${id}`,
    );
    return response.data;
}

export async function createExternalTask(
    projectId: string,
    data: ExternalTaskFormModel,
): Promise<ExternalTask> {
    const response = await getAxiosInstance().post<ExternalTask>(
        `/project/${projectId}/external-task`,
        data,
    );
    return response.data;
}

export async function updateExternalTask(
    projectId: string,
    id: string,
    data: ExternalTaskFormModel,
): Promise<ExternalTask> {
    const response = await getAxiosInstance().put<ExternalTask>(
        `/project/${projectId}/external-task/${id}`,
        data,
    );
    return response.data;
}

export async function deleteExternalTask(
    projectId: string,
    id: string,
): Promise<void> {
    await getAxiosInstance().delete(
        `/project/${projectId}/external-task/${id}`,
    );
}

export interface CompleteExternalTaskRequest {
    completionDate?: string | null;
}

export async function completeExternalTask(
    projectId: string,
    id: string,
    data?: CompleteExternalTaskRequest,
): Promise<ExternalTask> {
    const response = await getAxiosInstance().post<ExternalTask>(
        `/project/${projectId}/external-task/${id}/complete`,
        data ?? {},
    );
    return response.data;
}

export async function reactivateExternalTask(
    projectId: string,
    id: string,
): Promise<ExternalTask> {
    const response = await getAxiosInstance().post<ExternalTask>(
        `/project/${projectId}/external-task/${id}/reactivate`,
    );
    return response.data;
}
